import React from 'react';
import { Wrapper } from 'AppReact';;
import styled from 'styled-components';

const template = styled.div`
    display: flex; 
    justify-content: center;`;

export default Wrapper(template);
